<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const { t } = useI18n();
const router = useRouter();

const goToCustomAttributes = () => {
  router.push({ name: 'attributes_list' });
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center w-full h-full gap-4 py-20 text-center"
  >
    <Icon icon="i-lucide-kanban-square" class="text-n-slate-9 size-10" />
    <div class="flex flex-col gap-1">
      <span class="text-base font-medium text-n-slate-12">
        {{ t('CONTACTS_LAYOUT.KANBAN.EMPTY_STATE.TITLE') }}
      </span>
      <span class="text-sm text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.KANBAN.EMPTY_STATE.DESCRIPTION') }}
      </span>
    </div>
    <Button
      :label="t('CONTACTS_LAYOUT.KANBAN.EMPTY_STATE.CTA')"
      size="sm"
      @click="goToCustomAttributes"
    />
  </div>
</template>
